// import dotenv from 'dotenv'
// dotenv.config()
require('dotenv').config()
import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  mounted: function () {
    this.$store.dispatch("init");
  }
}).$mount('#app')
